
import styled from "styled-components";
import { fontFamilies } from "components/shared/tokens/typography";

const COLORS = {
  text: "#293142",
  muted: "#767c8f",
  label: "#9197a6",
  border: "#e6e9ef",
  brand: "#ef4f5f",
};

export const DesktopPage = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
  padding: 40px 32px;
`;

export const TitleRow = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
`;

export const TitleBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const Title = styled.h1`
  margin: 0;
  color: ${COLORS.text};
  font-family: ${fontFamilies.semiBold};
  font-size: 24px;
  font-weight: 600;
  line-height: 30px;
`;

export const Actions = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const ActionButton = styled.button`
  border: 1px solid ${(props) => (props.$primary ? COLORS.brand : COLORS.border)};
  border-radius: 8px;
  padding: 12px 16px;
  background: ${(props) => (props.$primary ? COLORS.brand : "#ffffff")};
  color: ${(props) => (props.$primary ? "#ffffff" : COLORS.text)};
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  cursor: pointer;

  &:disabled {
    cursor: default;
    opacity: 0.55;
  }
`;

export const SummaryCard = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 8px;
  border-radius: 16px;
  padding: 24px;
  background: #ffffff;
`;

export const SummaryItem = styled.div`
  display: flex;
  align-items: center;
  min-width: 0;
  gap: 16px;
`;

export const SummaryIcon = styled.div`
  display: flex;
  width: 48px;
  height: 48px;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  border: 1px solid ${COLORS.border};
  border-radius: 12px;
  color: ${COLORS.text};
`;

export const SummaryValue = styled.span`
  display: flex;
  align-items: center;
  gap: 10px;
  color: ${COLORS.text};
  font-family: ${fontFamilies.semiBold};
  font-size: 18px;
  line-height: 24px;
`;
